"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var GroupFooter_styles_1 = require("./GroupFooter.styles");
var GroupFooter_base_1 = require("./GroupFooter.base");
exports.GroupFooter = Utilities_1.styled(GroupFooter_base_1.GroupFooterBase, GroupFooter_styles_1.getStyles, undefined, {
    scope: 'GroupFooter'
});
//# sourceMappingURL=GroupFooter.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/GroupedList/GroupFooter.js
// module id = 894
// module chunks = 0